import React from 'react';

const Heading = ({ className, children , style}) => {
    return (
        <div
            style={{
                color: '#3E3E4A',
                fontFamily: 'Poppins,sans-serif',
                fontSize: '24px',
                fontStyle: 'normal',
                fontWeight: 700,
                lineHeight: 'normal',
                textAlign: 'center',
                ...style
            }}
            className={className}
        >
            {children}
        </div>
    );
};

export default Heading;
